var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.446 10.43a4.938 4.938 0 1 1 6.984-6.984 4.938 4.938 0 0 1-6.984 6.984m3.018 2.766a1.236 1.236 0 0 1 1.709 1.15v6.42a1.235 1.235 0 1 1-2.47 0v-6.42a1.23 1.23 0 0 1 .76-1.15",
    clipRule: "evenodd"
  })));
};
export default SvgPin;